module.exports = __webpack_public_path__ + "1709dcef5a10e18e7291bd824c042fb3.fbx";